import React from 'react';
import { motion } from 'framer-motion';
import Reveal from './Reveal';

const Hero: React.FC = () => {
  return (
    <section id="home" className="bg-white">
      {/* Main Content */}
      <div className="container mx-auto px-4" style={{ paddingTop: '80px' }}>
        {/* Image Section - Larger width, no frame */}
        <div className="mb-12">
          <div className="max-w-[770px] md:max-w-[770px] mx-auto">
            <Reveal duration={1.6} delay={0.2}>
              <div className="overflow-hidden">
                <div className="relative">
                  <div
                    className="relative w-full"
                    style={{
                      aspectRatio: '16/9',
                      WebkitMaskImage: 'radial-gradient(ellipse at center, black 90%, transparent 100%)',
                      maskImage: 'radial-gradient(ellipse at center, black 90%, transparent 100%)',
                    }}
                  >
                    {/* First image (@top1.jpg) */}
                    <motion.img
                      src="/top1.jpg"
                      alt="トップ画像1"
                      width={1280}
                      height={720}
                      className="absolute inset-0 w-full h-full object-cover"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
                      loading="eager"
                      decoding="async"
                      fetchPriority="high"
                      onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
                    />

                    {/* Second image (@top2.jpg) overlays and fades in later */}
                    <motion.img
                      src="/top2.jpg"
                      alt="トップ画像2"
                      width={1280}
                      height={720}
                      className="absolute inset-0 w-full h-full object-cover"
                      style={{ pointerEvents: 'none' }}
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1], delay: 2.0 }}
                      decoding="async"
                      onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
                    />
                    {/* Overlay removed to avoid any perceived blur */}
                  </div>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
        {/* Divider removed per request */}
        {/* Text Content Section - Below Image */}
        <div className="max-w-4xl mx-auto text-center pb-12">
          <Reveal duration={1.2} delay={0.6}>
            <h2 
              className="text-lg sm:text-2xl md:text-3xl font-bold mb-6 whitespace-nowrap leading-snug"
              style={{ color: '#e3628d' }}
            >
              「無所属。右でも左でもなく真ん中」
            </h2>
          </Reveal>

          <Reveal duration={1.2} delay={0.9}>
            <div className="text-sm sm:text-base text-gray-600 leading-relaxed max-w-3xl mx-auto mb-8 space-y-2">
              <p>地域の声を聞き、もっと住みやすい町田にするために<br className="sm:hidden" />活動しています。</p>
              <p>編集者・ライターとして27年の経験。</p>
              <p>地域の声を政治に届けることを使命としています。</p>
            </div>
          </Reveal>

          <Reveal duration={1.0} delay={1.1}>
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
              <button
                className="btn text-sm sm:text-base px-6 py-4 whitespace-nowrap"
                onClick={() => {
                  const element = document.querySelector('#policies');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                政策を見る
              </button>
              <button
                className="btn btn-secondary text-sm sm:text-base px-6 py-4 whitespace-nowrap"
                onClick={() => {
                  const element = document.querySelector('#profile');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                プロフィール
              </button>
            </div>
          </Reveal>

          {/* YouTube Video */}
          <Reveal duration={1.2} delay={1.3}>
            <div className="max-w-3xl mx-auto px-4">
              <div className="relative w-full pt-[56.25%] rounded-xl overflow-hidden shadow-lg bg-black">
                <iframe
                  className="absolute top-0 left-0 w-full h-full"
                  src="https://www.youtube.com/embed/_3eYmmCmC-0"
                  title="うのつのぶこ 紹介動画"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  loading="lazy"
                ></iframe>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Hero;